import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';

import { DemoContextTree } from '@demo/data/demo-context';
import { ContextService, ContextTree } from '@system/context';

@Injectable()
export class DemoContextService extends ContextService {
  getContextTree(): Observable<ContextTree> {
    return of(DemoContextTree).pipe(delay(100));
  }
}
